import { KeyIFrameLocalStorage } from "../components/context-action-input";

const defaultUrl = import.meta.env.VITE_SERVICE

export default async function Fetch(route, init = {}, url = defaultUrl) {
  if (isIframe()) return await FetchWithApiKey(route, init, url);

  const token = localStorage.getItem("token");

  init.headers = { ...init.headers, "Authorization": `Bearer ${token}` };

  const request = fetch(url + route, init)
  let fail;
  const res = await request.catch(e => {
    fail = e;
  });

  if (fail) return Promise.reject(fail);

  // if (res.status === 401 ) {
  //   localStorage.removeItem('token');
  //   window.location.href = '/lab/login';
  // }

  if (res.status > 399) {
    let data = await res.json();
    return Promise.reject({ data, status: res.status })
  }

  if (res.status === 204) return null;

  return res.json()
}

function isIframe() {
  return window.location.href.includes("/iframe/");
}

export async function FetchPublic(route, init = {}, url = defaultUrl) {
  const res = await fetch(url + route, init);
  const contentType = res.headers.get('content-type') || '';
  const data = contentType.includes('application/json') ? await res.json() : null;
  if (res.status > 399) {
    return Promise.reject({ data, status: res.status });
  }
  return data;
}

export async function FetchWithApiKey(route, init = {}, url = defaultUrl) {
  const token = localStorage.getItem(KeyIFrameLocalStorage)
  init.headers = { ...init.headers, "Api-Key": `${token}` };

  const request = fetch(url + route, init);
  // const timeout = setTimeout(() => request.abort(), 10000);
  const res = await request;
  // clearTimeout(timeout);

  if (res.status === 401) {
    window.location = '/iframe/invalid';
    localStorage.removeItem(KeyIFrameLocalStorage)
  }

  return await res.json();
}
